(() => {
  /* ---------- Flavor colors: keyword → color ---------- */
  const FLAVORS = [
    ['blue raspberry', '#2F80ED'], ['blueberry', '#4F46E5'], ['blue', '#2F80ED'], ['azul', '#2F80ED'],
    ['cotton candy', '#F9A8D4'], ['algod', '#F9A8D4'], ['bubble', '#F472B6'], ['chicle', '#F472B6'], ['birthday', '#FBCFE8'], ['pastel', '#FBCFE8'],
    ['fruit punch', '#E11D48'], ['punch', '#E11D48'], ['watermelon', '#FB7185'], ['sand', '#FB7185'],
    ['strawberry', '#EF4444'], ['fresa', '#EF4444'], ['cherry', '#B91C1C'], ['cereza', '#B91C1C'], ['red', '#DC2626'], ['rojo', '#DC2626'],
    ['grape', '#7C3AED'], ['uva', '#7C3AED'], ['berry', '#6D28D9'], ['mora', '#6D28D9'], ['acai', '#6D28D9'],
    ['tangerine', '#FB8C1A'], ['orange', '#FB8C1A'], ['naranja', '#FB8C1A'], ['mandarin', '#FB8C1A'],
    ['peach', '#FDBA74'], ['durazno', '#FDBA74'], ['melocot', '#FDBA74'], ['mango', '#F59E0B'], ['tropical', '#F59E0B'], ['passion', '#F59E0B'], ['maracuy', '#F59E0B'],
    ['pineapple', '#FDE047'], ['piña', '#FDE047'], ['lemon', '#FACC15'], ['limón', '#FACC15'], ['limon', '#FACC15'], ['sour', '#C6E83A'],
    ['lime', '#84CC16'], ['green apple', '#65A30D'], ['apple', '#84CC16'], ['manzana', '#84CC16'], ['green', '#22C55E'], ['verde', '#22C55E'], ['mint', '#6EE7B7'], ['menta', '#6EE7B7'],
    ['coconut', '#F5F0E6'], ['coco', '#F5F0E6'],
    ['chocolate', '#6B3E26'], ['cocoa', '#6B3E26'], ['brownie', '#5A3220'], ['mocha', '#7B4B32'], ['coffee', '#6F4E37'], ['café', '#6F4E37'], ['cafe', '#6F4E37'],
    ['peanut', '#C89B5A'], ['maní', '#C89B5A'], ['caramel', '#C9822F'], ['caramelo', '#C9822F'], ['dulce de leche', '#C9822F'],
    ['cinnamon', '#B7743E'], ['canela', '#B7743E'], ['churro', '#C68642'], ['cookie', '#A47148'], ['galleta', '#A47148'], ['cereal', '#E8B04B'], ['crunch', '#E8B04B'],
    ['vanilla', '#F3E3BF'], ['vainilla', '#F3E3BF'], ['cream', '#F3E3BF'], ['crema', '#F3E3BF'], ['rice', '#F1E7D3'], ['arroz', '#F1E7D3'],
    ['unflavored', '#CBD5E1'], ['sin sabor', '#CBD5E1'], ['natural', '#CBD5E1'],
  ];
  const FALLBACK = ['#F2B33D', '#7C3AED', '#22C55E', '#2F80ED', '#FB7185', '#FB8C1A'];

  const colorFor = (name) => {
    const n = name.toLowerCase();
    for (const [k, c] of FLAVORS) if (n.includes(k)) return c;
    let h = 0; for (const ch of n) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
    return FALLBACK[h % FALLBACK.length];
  };
  const inkFor = (hex) => {
    const v = parseInt(hex.slice(1), 16), r = (v >> 16) & 255, g = (v >> 8) & 255, b = v & 255;
    const L = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
    return L > 0.6 ? '#23102F' : '#FFFFFF';
  };

  /* ---------- Variant images (for the hover preview) ---------- */
  let productData = null;
  const loadProduct = async () => {
    if (productData) return productData;
    try {
      const path = window.location.pathname.replace(/\/$/, '');
      const res = await fetch(path + '.js', { headers: { Accept: 'application/json' } });
      if (res.ok) productData = await res.json();
    } catch (e) { /* preview stays off */ }
    return productData;
  };
  const imageFor = (optionIndex, value) => {
    if (!productData) return null;
    const v = productData.variants.find((x) => x.options[optionIndex] === value && x.featured_image);
    return v ? v.featured_image.src : null;
  };

  /* ---------- Decorate pills ---------- */
  const labelText = (label) => {
    const clone = label.cloneNode(true);
    clone.querySelectorAll('.visually-hidden, .ds-flv-tip').forEach((n) => n.remove());
    return clone.textContent.trim();
  };

  const decorate = () => {
    document.querySelectorAll('product-info .product-form__input--pill').forEach((fs) => {
      const fieldsets = Array.from(fs.closest('variant-selects, .product-form__input')?.parentElement?.querySelectorAll('.product-form__input') || [fs]);
      const optionIndex = Math.max(0, fieldsets.indexOf(fs));
      const images = new Set();
      fs.querySelectorAll('input[type="radio"] + label').forEach((label) => {
        const value = labelText(label);
        const c = colorFor(value);
        label.style.setProperty('--flv', c);
        label.style.setProperty('--flv-ink', inkFor(c));
        const src = imageFor(optionIndex, value);
        if (src) images.add(src);
        if (src && !label.querySelector('.ds-flv-tip')) {
          const tip = document.createElement('span');
          tip.className = 'ds-flv-tip';
          tip.setAttribute('aria-hidden', 'true');
          const img = document.createElement('img');
          img.src = src + (src.includes('?') ? '&' : '?') + 'width=260';
          img.alt = ''; img.loading = 'lazy';
          tip.appendChild(img);
          label.appendChild(tip);
        }
      });
      if (images.size < 2) fs.querySelectorAll('.ds-flv-tip').forEach((t) => t.remove());

      // Legend shows the chosen flavor
      const legend = fs.querySelector('legend');
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (legend && checked) {
        const value = checked.value;
        let span = legend.querySelector('.ds-flv-current');
        if (!span) { span = document.createElement('span'); span.className = 'ds-flv-current'; legend.appendChild(span); }
        if (span.dataset.v !== value) {
          span.dataset.v = value;
          const c = colorFor(value);
          span.innerHTML = '';
          const b = document.createElement('b');
          b.textContent = value;
          b.style.setProperty('--flv', c); b.style.setProperty('--flv-ink', inkFor(c));
          span.append(':', b);
        }
      }
    });

    // Shine on the add-to-cart button
    document.querySelectorAll('product-info .product-form__submit').forEach((btn) => {
      if (!btn.querySelector('.ds-shine')) { const s = document.createElement('span'); s.className = 'ds-shine'; s.setAttribute('aria-hidden', 'true'); btn.appendChild(s); }
    });
    updateSticky();
  };

  /* ---------- Sticky add-to-cart (phones) ---------- */
  let bar, barFlv, barPrice, barBtn, mainBtn;
  const priceText = () => {
    const box = document.querySelector('product-info .price');
    if (!box) return '';
    const el = box.classList.contains('price--on-sale')
      ? box.querySelector('.price__sale .price-item--last')
      : box.querySelector('.price__regular .price-item--regular');
    return el ? el.textContent.trim() : '';
  };
  const chosen = () => Array.from(document.querySelectorAll('product-info .product-form__input input[type="radio"]:checked, product-info .product-form__input select'))
    .map((i) => i.value).filter(Boolean).join(' · ');
  const updateSticky = () => {
    if (!bar) return;
    mainBtn = document.querySelector('product-info .product-form__submit');
    barFlv.textContent = chosen() || document.title.split('–')[0].trim();
    barPrice.textContent = priceText();
    barBtn.disabled = !mainBtn || mainBtn.disabled;
    barBtn.textContent = mainBtn && mainBtn.disabled ? 'Agotado' : 'Agregar';
  };
  const initSticky = () => {
    mainBtn = document.querySelector('product-info .product-form__submit');
    if (!mainBtn || !('IntersectionObserver' in window)) return;
    bar = document.createElement('div');
    bar.className = 'ds-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<span class="ds-sticky-atc__info"><span class="ds-sticky-atc__flv"></span><span class="ds-sticky-atc__price"></span></span><button type="button" class="ds-sticky-atc__btn" tabindex="-1">Agregar</button>';
    document.body.appendChild(bar);
    barFlv = bar.querySelector('.ds-sticky-atc__flv');
    barPrice = bar.querySelector('.ds-sticky-atc__price');
    barBtn = bar.querySelector('.ds-sticky-atc__btn');
    barBtn.addEventListener('click', () => {
      const btn = document.querySelector('product-info .product-form__submit');
      if (btn && !btn.disabled) btn.click();
    });
    const io = new IntersectionObserver(([e]) => {
      const past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', past);
      document.documentElement.classList.toggle('ds-sticky-on', past);
    });
    io.observe(mainBtn.closest('.product-form__buttons') || mainBtn);
    updateSticky();
  };

  /* ---------- Boot + keep in sync when Dawn re-renders on variant change ---------- */
  const start = async () => {
    if (!document.querySelector('product-info')) return;
    decorate();
    initSticky();
    await loadProduct();
    decorate();
    let t;
    new MutationObserver(() => { clearTimeout(t); t = setTimeout(decorate, 30); })
      .observe(document.querySelector('product-info'), { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
